package com.essntl.features.client.ui.addeditclient

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.proposal.domain.model.ProposalModel

data class AddEditClientState(
    val client: MutableState<ClientModel> = mutableStateOf(ClientModel.empty),
    val getClient: State<ClientModel> = State(),
    val getProposals: State<List<ProposalModel>> = State(),
    val getItineraries: State<List<ItineraryModel>> = State(),
    val addEditClient: State<ClientModel> = State(),
    val isEditEnabled: Boolean = false,
) {
    val isLoading
        get() = getClient.isLoading ||
            getProposals.isLoading ||
            getItineraries.isLoading

    val isFailure
        get() = getClient.isFailure ||
            getProposals.isFailure ||
            getItineraries.isFailure
}
